import { render, staticRenderFns } from "./pay-setting.vue?vue&type=template&id=0650bbb6&scoped=true"
import script from "./pay-setting.vue?vue&type=script&lang=js"
export * from "./pay-setting.vue?vue&type=script&lang=js"
import style0 from "./pay-setting.vue?vue&type=style&index=0&id=0650bbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650bbb6",
  null
  
)

export default component.exports